import { useState } from 'react';

export const useRenderPhaseSync = <T>(externalValue: T) => {
    const [localValue, setLocalValue] = useState<T>(externalValue);
    const [prevExternal, setPrevExternal] = useState<T>(externalValue);

    if (externalValue !== prevExternal) {
        setPrevExternal(externalValue);
        if (externalValue !== localValue) {
            setLocalValue(externalValue);
        }
    }

    return [localValue, setLocalValue] as const;
};
